import styled from 'styled-components';

const CalculatorWrapper = styled.div`
  width: 80%;
  margin-left: 5%;
`;

export default CalculatorWrapper;
